import React, { memo, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TopPanel from 'components/top-panel/TopPanel';
import SidebarPanel from 'components/sidebar/SidebarPanel';
import useToggle from 'hooks/useToggle';

const BaseLayout = () => {
  const [sideBarToggle, setSideBarToggle] = useToggle('sidebarOpen');
  const printRef = React.useRef();

  useEffect(() => {
    window.addEventListener('keypress', (event) => {
      if (event && event.keyCode == 91) {
        setSideBarToggle(false);
      }
      if (event && event.keyCode == 93) {
        setSideBarToggle(true);
      }
    });
  }, []);

  return (
    <>
      <div className='flex flex-row relative'>
        <div
          className={`aside-container${
            sideBarToggle ? ' sidebar-full' : ' sidebar-small'
          }`}
        >
          <SidebarPanel
            sideBarToggle={sideBarToggle}
            setSideBarToggle={setSideBarToggle}
          />
        </div>
        <div
          className={`base-container${
            sideBarToggle ? ' base-container-small' : ' base-container-full'
          }`}
        >
          <div className='header-container'>
            <TopPanel printRef={printRef} />
          </div>
          <main
            ref={printRef}
            className='main-container with-max-width bg-[#F2F3F7] h-[calc(100vh-70px)] overflow-y-auto my-scroll'
          >
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default memo(BaseLayout);
